<script lang="ts" setup>

import {type SourceDetails} from "@/domain/type/synchro.api.type.ts";
import {Source} from "@/domain/type/source.type.ts";

const props = defineProps<{
  details: SourceDetails[],
  source: Source,
  link: string
}>();

function filterLink(link: string): string {
  if(import.meta.env.VITE_AMMON_BASE_URL_OLD === import.meta.env.VITE_AMMON_BASE_URL) {
    return link;
  }
  return link.replace(import.meta.env.VITE_AMMON_BASE_URL_OLD + '/AMMON', import.meta.env.VITE_AMMON_BASE_URL + '/BO/s')
}

function filterText(text: string | number): string | number {
  if (text === null || text === undefined) {
    return ''
  }
  if (typeof text === 'number') {
    return text
  }
  return text.replace(/&nbsp;/gi, ' ')
}
</script>

<template>
  <v-card v-if="details && details.length > 0" class="source-card" elevation="0">
    <v-card-text>
      <div class="">
        <a :href="filterLink(link)" class="d-inline-flex align-center source-link" target="_blank">
          <v-icon color="blue" icon="mdi-link-variant" size="small" class="mr-1"/>
          Lien vers {{ source }}
        </a>
      </div>
      <div v-for="(detail,i) in details" class="py-1 text-left">
        <span v-if="detail.label !== 'Lien'" :class="`label${i}`" class="text-grey-darken-1 font-weight-bold">{{ detail.label }}: </span>
        <span v-if="detail.label !== 'Lien'" :class="`value${i}`" class="text-grey" v-html="filterText(detail.val)"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.source-card {
  width: 100%;
  position: relative;
}

.source-logo {
  width: 50px;
}

.source-link {
  text-decoration: none;
}
</style>
